import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import CheckListMenu from '../../components/step-4/checkListMenu';
import VerificationForm from '../../components/step-4/verificationForm';

const Step4 = ({ saveEvent }) => {
  const { eventData } = useSelector((state) => state.eventCreate);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="flex flex-1 w-full flex-col md:flex-row gap-6">
        <div className="leftMenu w-full md:w-[40%] md:pr-6">
          <CheckListMenu eventData={eventData} />
        </div>
        <div className="rightContent w-full md:flex-1">
          <VerificationForm eventData={eventData} saveEvent={saveEvent} />
        </div>
      </div>
    </>
  );
};

export default Step4;
